import React from 'react';
import './blog.scss';
import BlogCard from './BlogCard';
import { Link } from 'react-router-dom';

const Blogs = ({ blogs, title = 'Catch Our Blog & Updates' }) => {
  return (
    <div className="desktop-blogs">
      <div className="justify-content--space-between">
        <div className="desktop-blogs--title">{title}</div>
        <Link
          to="/blogs"
          className="button action-link more desktop-blogs--link"
        >
          View All
        </Link>
      </div>
      <div className="desktop-blogs--container">
        {blogs.map(blog => (
          <BlogCard key={blog.blogId} blog={blog} />
        ))}
      </div>
    </div>
  );
};

export default Blogs;
